const caculateTime = function (time, type) {
  var totalTime = ''
  if (type === 2) {
    if (time) {
      time = parseInt(time)
      let minutes = (time / (1000 * 60))
      if (minutes <= 0) {
        return 0
      } else {
        totalTime = parseInt(minutes)
      }
      return totalTime
    } else {
      return 0
    }
  } else if (type === 1) {
    if (time) {
      time = parseInt(time)
      let hours = (time / (60 * 60)).toFixed(
        2
      )
      if (hours > 0) {
        hours = parseInt(hours)
      } else {
        hours = 0
      }
      let minutes = Math.round((time % (60 * 60)) / (60))
      if (hours === 0) {
        if (minutes <= 0) {
          return '00:00'
        } else {
          if (parseInt(minutes) < 10) {
            totalTime = '00:0' + parseInt(minutes)
          } else {
            totalTime = '00:' + parseInt(minutes)
          }
        }
      } else {
        if (parseInt(hours) < 10) {
          if (parseInt(minutes) < 10) {
            if (parseInt(minutes) === 0 || !minutes) {
              totalTime = '' + parseInt(hours) + ':00'
            } else {
              totalTime = '' + parseInt(hours) + ':0' + parseInt(minutes)
            }
          } else {
            totalTime = '0' + parseInt(hours) + ':' + parseInt(minutes)
          }
        } else {
          if (parseInt(minutes) < 10) {
            if (parseInt(minutes) === 0 || !minutes) {
              totalTime = '' + parseInt(hours) + ':00'
            } else {
              totalTime = '' + parseInt(hours) + ':0' + parseInt(minutes)
            }
          } else {
            totalTime = '' + parseInt(hours) + ':' + parseInt(minutes)
          }
        }
      }
      return totalTime
    } else {
      return '00:00'
    }
  } else {
    if (time) {
      time = parseInt(time)
      let hours = (time / (1000 * 60 * 60)).toFixed(
        2
      )
      if (hours > 0) {
        hours = parseInt(hours)
      } else {
        hours = 0
      }
      let minutes = Math.round((time % (1000 * 60 * 60)) / (1000 * 60))
      if (hours === 0) {
        if (minutes <= 0) {
          return '00:00'
        } else {
          if (parseInt(minutes) < 10) {
            totalTime = '00:0' + parseInt(minutes)
          } else {
            totalTime = '00:' + parseInt(minutes)
          }
        }
      } else {
        if (parseInt(hours) < 10) {
          if (parseInt(minutes) < 10) {
            if (parseInt(minutes) === 0 || !minutes) {
              totalTime = '0' + parseInt(hours) + ':00'
            } else {
              totalTime = '0' + parseInt(hours) + ':0' + parseInt(minutes)
            }
          } else {
            totalTime = '0' + parseInt(hours) + ':' + parseInt(minutes)
          }
        } else {
          if (parseInt(minutes) < 10) {
            if (parseInt(minutes) === 0 || !minutes) {
              totalTime = '' + parseInt(hours) + ':00'
            } else {
              totalTime = '' + parseInt(hours) + ':0' + parseInt(minutes)
            }
          } else {
            totalTime = '' + parseInt(hours) + ':' + parseInt(minutes)
          }
        }
      }
      return totalTime
    } else {
      return '00:00'
    }
  }
}

export default caculateTime



// WEBPACK FOOTER //
// ./src/utils/caculateTime.js